import { IIconStyles, IStackStyles, ITheme, memoizeFunction } from '@fluentui/react';
import { pcpRedPalette } from './themes/palette';

const notificationIconTinyPaddingREM = '0.0625rem'  //1px
const notificationIconTinySizeREM = '0.625rem';  //10px

export const notificationIconXSmallContainerStyles = memoizeFunction(
    (theme: ITheme, horizontalAlign: 'left' | 'right'): IIconStyles => ({
        root: Object.assign(
            {
                borderRadius: notificationIconTinySizeREM, // Create a css circle. This should match the height.
                height: notificationIconTinySizeREM,
                minWidth: notificationIconTinySizeREM, // use min-width over width as we want to extend the width of the notification icon when contents is more than one character (e.g. 9+)
                background: pcpRedPalette.notificationForeground,
                padding: notificationIconTinyPaddingREM,

                // positioning to place the badge within the button appropriately. Button DOM-element should have css 'position' other than 'static'.
                position: 'absolute',
                top: 0,
            },
            horizontalAlign == 'right' ?
                { right: 0 } :
                { left: 0 }
            ) as IIconStyles
    })
);

export const notificationTextXSmallStyles = memoizeFunction(
    (theme: ITheme): IStackStyles => ({
        root: {
            color: 'white',
            fontSize: '8px',    //smaller then default value of theme.fonts.tiny.fontSize
            lineHeight: '1em',
            paddingLeft: '1px'  //improves text horizontal align inside red circle for small font-size
        }
    })
);